module.exports = __webpack_public_path__ + "static/img/img_19.ee694bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events_gallery/img_19.jpg
// module id = P6hI
// module chunks = 0